<template>
    <card-table  id="confrontacao-indicador-real" class="table-borderless">

      <thead>
      <tr>
        <th class="text-muted tamanho" v-if="ordenar"></th>
        <th class="text-muted" style="width: 8%">Confrontação </th>
        <th class="text-muted" style="width: 5%">Metragem </th>
        <th class="text-muted" style="width: 20%">Confrontante </th>
        <th class="text-muted" style="width: 12%">Lacuna</th>
        <th class="text-muted" style="width: 12%">Sobreposição</th>
        <th class="text-muted" style="width: 37%">Vínculo</th>
        <th class="text-muted" style="width: 1%;vertical-align: middle; text-align: center" v-if="!visualizar">
          <a class="icon" href="" @click.prevent="adicionarConfrontacao()">
            <i class="fa fa-plus-square"></i>
          </a>
        </th>
      </tr>
      </thead>
      <draggable v-model="confrontacoes" @end="$emit('ordenar', 'confrontacoes', confrontacoes)" ghost-class="ghost"
                 handle=".move" tag="tbody" class="table-areas">
        <tr v-for="(confrontacao, i) in confrontacoes" :key="'item' + i">
          <td class="text-center icon move" v-if="ordenar">
            <span class="icon move">
              <i class="fas fa-arrows-alt"></i>
            </span>
          </td>
          <td class="form-group">
            <input :disabled="!edicao" class="form-control form-control-xs" v-model="confrontacao.confrontacao" type="text" />
          </td>

          <td class="form-group">
            <input :disabled="!edicao" class="form-control form-control-xs" v-model="confrontacao.metragem" type="text" />
          </td>

          <td class="form-group">
            <input :disabled="!edicao" class="form-control form-control-xs" v-model="confrontacao.confrontante" type="text" />
          </td>
          <td  class="form-group">
            <v-input type="v-select" :options="opcoesLacunaSobreposicao" v-model="confrontacao.lacuna" :style="{maxWidth: '135px', minWidth: '135px'}"/>
          </td>
          <td  class="form-group">
            <v-input type="v-select" :options="opcoesLacunaSobreposicao" v-model="confrontacao.sobreposicao" :style="{maxWidth: '135px', minWidth: '135px'}"/>
          </td>
          <td class="form-group">
            <div class="d-flex align-items-start">
              <v-input type="v-select" :options="opcoesTipoVinculo" v-model="confrontacao.tipoVinculo" @change="onTipoVinculoChange(confrontacao)" style="min-width: 135px; max-width: 135px" class="mr-1"/>
              <buscar-fichas v-if="!confrontacao.tipoVinculo || confrontacao.tipoVinculo === 'MATRICULA'" :livro="'MATRICULA'" :status="'ABERTA'" :multiple="false" :allow-add="false" :valor-inicial-individual="confrontacao.matricula" @selecionar="selecionarMatricula($event,confrontacao)" @codigoIndividual="validarCodigoMatricula($event,confrontacao)" class="col"/>
              <buscar-fichas-externas v-else :livro="'MATRICULA'" :multiple="false" :selecionarLivros="false" :showLabels="false" :valor-inicial-individual="confrontacao.indicadorRealExterno" @selecionar="selecionarIndicadorRealExterno($event,confrontacao)" class="col" :style="{marginRight: '2px', paddingRight: '2px', columnGap: '3px', maxWidth: '140px'}"/>
              <input v-if="confrontacao.tipoVinculo === 'INDICADOR_REAL_EXTERNO' && confrontacao.indicadorRealExterno && confrontacao.indicadorRealExterno.livroLetra" disabled class="form-control form-control-xs" :style="{maxWidth: '90px'}" :value="confrontacao.indicadorRealExterno.livroLetra" placeholder="Letra"/>
            </div>
          </td>

          <td class="text-center" v-if="!visualizar">
            <a class="icon" href="" @click.prevent="removerConfrotacoes(i)">
              <i class="fa fa-times"></i>
            </a>
          </td>
        </tr>
      </draggable>
      <tr v-if="confrontacoes.length === 0">
        <td colspan="100%">
          <div class="alert alert-warning alert-sm mb-0">
            Nenhuma confrontação cadastrada
          </div>
        </td>
      </tr>

      <tfoot></tfoot>

    </card-table>
</template>

<script>
  import CardTable from "@/components/Layout/components/CardTable.vue";
  import draggable from "vuedraggable";
  import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";

  export default {
      components: {CardTable, draggable},
      props : {
        confrontacoes : {type : Array, required : true},
        visualizar: {type : Boolean, default : false},
        edicao: {type : Boolean, default : true},
        ordenar: {type : Boolean, default : false}
      },

      name: "ConfrontacaoIndicadorReal",
      data(){
        return {
          opcoesLacunaSobreposicao: IndicadorRealBusiness.loadOpcoesConfrontacao(),
          opcoesTipoVinculo: [
            {id: 'MATRICULA', nome: 'Matrícula'},
            {id: 'INDICADOR_REAL_EXTERNO', nome: 'Ind. Real Externo'}
          ]
        }
      },

      watch: {
        confrontacoes: {
          handler(lista) {
            if (lista) {
              lista.forEach(confrontacao => {
                if (confrontacao.tipoVinculo === undefined || confrontacao.tipoVinculo === null) {
                  this.$set(confrontacao, 'tipoVinculo', 'MATRICULA');
                }
                if (confrontacao.indicadorRealExterno === undefined) {
                  this.$set(confrontacao, 'indicadorRealExterno', null);
                }
              });
            }
          },
          immediate: true
        }
      },

      methods:{

        removerConfrotacoes(index) {
          this.$nextTick(() => {
            if (this.confrontacoes && this.confrontacoes.length) {
              this.confrontacoes.splice(index, 1);
            }
          });
        },

        adicionarConfrontacao(){
          this.$nextTick(() => {
            this.confrontacoes.push({confrontacao: '', metragem: '', confrontante: '',lacuna:'',sobreposicao:'',matricula:{},tipoVinculo:'MATRICULA',indicadorRealExterno:null});
          });
        },

        selecionarMatricula(itens, confrontacao) {
          let matriculaSelecionada = itens[0];
          if (matriculaSelecionada) {
            confrontacao.matricula = {
              id: matriculaSelecionada.id,
              codigo: matriculaSelecionada.codigo,
              livroLetra: matriculaSelecionada.livroLetra
            };
          } else {
            confrontacao.matricula = null;
          }
        },
        validarCodigoMatricula(codigo,confrontacao){
          if(!codigo){
            confrontacao.matricula = null;
          }
        },

        selecionarIndicadorRealExterno(itens, confrontacao) {
          let selecionado = itens[0];
          if (selecionado) {
            confrontacao.indicadorRealExterno = {
              id: selecionado.id,
              codigo: selecionado.codigo,
              tipo: selecionado.tipo,
              serventia: selecionado.serventia,
              livroLetra: selecionado.livroLetra
            };
            confrontacao.matricula = null;
          } else {
            confrontacao.indicadorRealExterno = null;
          }
        },

        onTipoVinculoChange(confrontacao) {
          if (confrontacao.tipoVinculo === 'MATRICULA') {
            confrontacao.indicadorRealExterno = null;
          } else {
            confrontacao.matricula = null;
          }
        }
      }

    }
</script>

<style scoped lang=scss>
  .tamanho {
    width: 1%;
    max-width: 36px;
  }
</style>
